import React from 'react';
import { LockIcon, PackageCheckIcon, ShieldCheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { checkoutTrust, paymentMethods, shippingCarriers } from '../../data/shopify';
import { freeShippingLive } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
import { BrandLogo } from './BrandLogo';

/** Accepted payment methods + shipping carrier, shown beside every checkout CTA. */
export function PaymentTrust({
  className = ''
}: {
  className?: string;
}) {
  const {
    t,
    lang
  } = useLanguage();
  const es = lang === 'es';
  const methods = paymentMethods.filter(m => m.enabled);
  return <div className={`grid gap-6 md:grid-cols-[1.6fr_1fr] md:gap-10 ${className}`} data-id="element-889" data-mp="4sd4ipet6mxh">
      <div data-id="element-890" data-mp="9olfdqlz3tyu">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-white" data-id="element-891" data-mp="9rg4hvfxm2yl">
          <LockIcon className="h-3.5 w-3.5 text-marine" aria-hidden data-id="element-892" data-mp="emn1ylilybf2" />
          {t('trust.secure')}
        </p>
        <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[12px] text-titanium" data-id="element-893" data-mp="2tvragf6nxbcr">
          {checkoutTrust.points.map(p => <li key={p} className="flex items-center gap-1.5" data-id="element-894" data-mp="2ovwh84zf09oj">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-marine" aria-hidden data-id="element-895" data-mp="2jxl8jxkuw57w" />
              {p}
            </li>)}
        </ul>
        <ul className="mt-3 flex flex-wrap gap-1.5" aria-label={es ? 'Métodos de pago aceptados' : 'Accepted payment methods'} data-id="element-896" data-mp="2f01vh0zw9yhj">
          {methods.map(m => <li key={m.id} data-id="element-897" data-mp="37npewcpfij2l">
              <BrandLogo src={m.icon} label={m.label} data-id="element-898" data-mp="37ogxmmxxgmbg" />
            </li>)}
        </ul>
      </div>

      <div data-id="element-899" data-mp="32vebv0ze6h5t">
        <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.12em] text-titanium" data-id="element-900" data-mp="32v4hz2b87puu">
          <PackageCheckIcon className="h-3.5 w-3.5 text-marine" aria-hidden data-id="element-901" data-mp="2xvjmj1v9lzmv" />
          {es ? 'Envío' : 'Shipping'}
        </p>
        <div className="mt-3 flex items-center gap-3" data-id="element-902" data-mp="3qm9xthh62i55">
          {shippingCarriers.map(c => <BrandLogo key={c.id} src={c.logo} label={c.label} className="h-7 w-[104px] bg-white px-1.5 py-1" data-id="element-903" data-mp="1oorixt7kznd9" />)}
          <p className="text-xs leading-snug text-titanium" data-id="element-904" data-mp="1to42o535oebm">
            {freeShippingLive() ? es ? 'Envío gratis por USPS en todos los pedidos de EE.UU.' : 'Free USPS shipping on every U.S. order' : es ? 'Envío por USPS · tarifa calculada al pagar' : 'Ships via USPS · rates calculated at checkout'}
            <br data-id="element-905" data-mp="1a0d5kocjggig" />
            {es ? 'Número de rastreo por correo. ' : 'Tracking number emailed. '}
            <Link to="/shipping" className="underline decoration-white/20 underline-offset-2 hover:text-white" data-id="element-906" data-mp="w0vlgma6trff">
              {es ? 'Política de envío' : 'Shipping policy'}
            </Link>
          </p>
        </div>
      </div>
    </div>;
}